import { TFunction } from 'i18next';
import { getCompareColumns } from 'components/DocumentsResearch/helpers/columns';
import { pdfHelper } from 'helpers/pdfHelper';
import { exportHelper } from 'helpers/excelHelper';
import { ICompareDataType } from 'components/DocumentsResearch/interfaces';
import { IDocData } from 'interfaces';
import api from 'api';
import { MessageInstance } from 'antd/es/message/interface';

export const exportReportExcel = async (
  documentData: IDocData,
  documentName: string,
  documentID: string,
  documentRoomID: string,
  t: TFunction,
  messageApi?: MessageInstance | null,
) => {
  try {
    const reportColumns = getCompareColumns(t);
    const allData = documentData.infoData.concat(documentData.infoCompare).filter(el => el.key !== t('Report.info.description'));
    
    exportHelper(allData, reportColumns, `${t('Report.report.title')}: ${documentName}`)
  } catch (e) {
    messageApi?.error(t('Report.errors.exportExcel'));
  }

  await api.createCustomLog({
    action_type: 'download',
    log_type: 'research_report',
    entity_id: documentID,
    room_id: documentRoomID,
  });
};

export const exportReportPdf = async (
  documentData: IDocData,
  documentName: string,
  documentID: string,
  documentRoomID: string,
  t: TFunction,
  messageApi?:  MessageInstance | null,
) => {
  try {
    const reportColumns = getCompareColumns(t);
    const allData = documentData.infoData.concat(documentData.infoCompare);

    pdfHelper<ICompareDataType>(
      allData.filter(el => el.key !== t('Report.info.description')),
      reportColumns,
      `${t('Report.report.title')}: ${documentName}`,
      'export'
    )
  } catch (e) {
    messageApi?.error(t('Report.errors.exportPdf'));
  }    

  await api.createCustomLog({
    action_type: 'download',
    log_type: 'research_report_as_pdf',
    entity_id: documentID,
    room_id: documentRoomID,
  });
};
